export default {
  home: '首页',
  login: '登录',
  logout: '退出',
  download_center: '下载中心',
  designate: '名称',
  title: '远程服务系统',
  language: '语言',
  chinese: '简体中文',
  english: '英文',
  beginTime: '开始时间',
  endTime: '结束时间',
  account_number: '请输入账号',
  projectNameTip: '请输入项目名称',
  psnCode: '请输入PSN码',
  to: '至',
  commissionDetailTitle: '项目名称-控制PSN 调试记录',
  number: '序号',
  time: '时间',
  account: '账号',
  upgradeFile: '下发升级文件',
  printType: '打印类型',
  all: '全部信息',
  fireInformation: '火警信息',
  faultInformation: '故障信息',
  linkageInformation: '联动信息',
  feedbackInformation: '声光反馈信息',
  superviseInformation: '监管信息',
  operatorInformation: '操作信息',
  otherInformation: '其他信息',
  projectName: '项目名称',
  agencyName: '经销商',
  psn: '控制器PSN',
  fieldStaffName: '现场人员姓名',
  fieldStaffPhone: '现场人员电话',
  fieldStaffJob: '现场人员职务',
  operation: '操作',
  detail: '详情',
  download: '下载',
  content: '内容',
  queryButton: '查询',
  saveButton:'查询并保存',
  systemSetting: '系统配置',
  boardInformation: '板卡信息',
  fieldComponent: '现场部件',
  boardType: '板卡类型',
  boardNumber: '盘号',
  version: '软件版本',
  psn1: 'PSN',
  loopNumber: '回路号',
  loopNo: '回路号',
  loopNum:'回路板号',
  loop: '回路',
  loopboard:'回路板卡',
  multiline:'多线控制盘',
  busline:'总线控制盘',
  gasExtinguishing:'气体灭火盘',
  broadcast:'总线广播盘',
  eventRecord:'事件记录器',
  crt:'图形显示装置',
  gateway:'传输设备',
  gprs:'GRPS',
  wifi:'WIFI',
  serial:'串口调试',
  interfaceCard:'接口卡',
  nodata:'暂无数据',
  devType: 'devType',
  num: 'num',
  total: '合计',
  loginName: '用户名',
  name: '姓名',
  email: '邮箱',
  orgNames: '经销商',
  phone: '电话',
  oldPwd: '旧密码',
  newPwd: '新密码',
  confirmPwd: '确认密码',
  role: '角色',
  edit: '修改',
  editPassword: '修改密码',
  auto: '自动',
  manual: '手动',
  allow: '允许',
  machineNo: '机器号',
  panelNumber: '控制器号',
  soundAndLightStart: '声光启动',
  soundAndLightStop: '声光停止',
  silencing: '消音',
  reset: '复位',
  proofreading: '校时',
  inspect: '检查',
  close: '关闭',
  open: '开启',
  realTimeValue: '实时值',
  rangeValue: '合理范围值',
  discNumber: '多线盘号',
  disc: '多线',
  value: '数值',
  componentType: '部件类型',
  foundationType: '基础类型',
  customerType: '用户类型',
  quantity: '数量',
  model: '型号',
  operationMode: '运行模式',
  enable: '允许',
  disable: '禁止',
  panelTime: '控制器时间',
  jbf: 'JBF5009',
  detailed: '明细',
  codeNo: '部件号',
  addressNumber: '地址号',
  singleProgramming: '单点联动编程信息查询',
  totalLinkageProgramming: '全部联动编程信息查询',
  singleAnnotation: '单点注释信息查询',
  allAnnotation: '全部注释信息查询',
  sendToControllerProgress: '下发至控制器进度',
  controllerUploadProgress:'控制器上传进度',
  export: '导出',
  configDownload: '列表下发',
  localUpload: '本地上传',
  controllerUpload: '控制器上传',
  startupTime: '启动时间',
  actionTime: '动作时间',
  logicalExpression: '逻辑表达式',
  panelUpload: '读取全部联动编程',
  readAllHistory:'读取全部历史记录',
  notes:'读取全部注释',
  fileDownload: '文件下发',
  equipmentType: '设备类型',
  address: '地址',
  event: '事件',
  annotation: '注释',
  analog: '模拟量',
  addressTip: '请输入地址',
  noteTip: '请输入注释信息',
  localAddress: '本机地址',
  networkingMode: '组网模式',
  selctNetworkMode: '请选择组网模式',
  receiveFire: '接收火警信息',
  receiveLinkage: '接收联动信息',
  receiveFault: '接收故障信息',
  networkController: '组网控制器',
  sendNeedRegistPanel: '发送控制器需要注册',
  panelPSN: '控制器PSN',
  panelType: '控制器类型',
  panelAnnotation: '控制器注释',
  panelVersion: '控制器版本',
  siteInitiation: '部位起始',
  siteEnd: '部位结束',
  analogAlarm: '模拟报警',
  set: '设置',
  componentNumber: '部位号',
  startUp: '启动',
  stop: '停止',
  autoRegister: '自动登记',
  manualRegister: '手动登记',
  loopAutoRegister: '回路部件自动登记',
  loopManualRegister: '回路部件手动登记',
  startDebugging: '开始调试',
  waitingForConnection: '等待连接',
  dynamicPassword: '动态口令',
  fire: '火警',
  fault: '故障',
  supervision: '监管',
  shield: '屏蔽',
  feedback: '联动/反馈',
  relieve: '解除',
  printerSwitch: '打印机开关',
  printSpeed: '打印机速度',
  startAddress: '开始地址',
  endAddress: '结束地址',
  uploaded: '已上传',
  item: '条',
  fast: '快',
  slow: '慢',
  onlyAdd: '保留原登记信息，仅新增',
  descr: '注释信息',
  delete: '删除',
  save: '保存',
  trialDays: '试用天数',
  remainingDays: '剩余天数',
  setTimes: '设置次数',
  serialNumber: '序列号',
  state: '状态',
  type: '类型',
  recentQuery: '最近查询',
  powerSupplyVoltage: '电源工作电压',
  input: '输入',
  output: '输出',
  backupPower: '备电',
  confirm: '确定',
  cancel: '取消',
  backgroundCurrent: '背景电流',
  stateCurrent: '状态电流',
  success:'成功',
  nostart: '未开始',
  completed:'完成',
  processing: '进行中',
  statType: '事件类型',
  fail:'失败',
  "sidebar": {
    "monitor": '监控',
    "query": '查询',
    "test": '测试',
    "setting": '设置',
    "install": '安装',
    "manage": '管理'
  },
  "manage": {
    "account": '账号管理',
    "standardItem": '标准项管理',
    "debugRecord": '调试记录',
    "authority": '权限管理',
    "panelFunction": '控制器功能',
    "archive": '项目存档',
    "product":'产品信息',
    "beginDebug":'开始调试'
  },
  "system": {
    "unitTest": '系统单元测试',
    "password": '设置密码',
    "operationMode": '设置运行模式',
    "cleaningTreatment": '清除处理',
    "networkController": '设置组网控制器',
    "language": '设置语言'
  },
  "install": {
    "registrationOfComponent": '回路部件手自动登记',
    "analogAlarm": '部件模拟报警',
    "fixedPointAddressing": '定点编址',
    "remoteUpgrade": '远程升级'
  },
  "setting": {
    "printer": '设置打印机',
    "manualStartStop": '设置手动启停设备',
    "componentShielding": '设置部件屏蔽'
  },
  "test": {
    "simulationCurve": '探测器模拟曲线',
    "statusBrowsing": '回路状态浏览',
    "dataQuery": '现场部件数据查询',
    "typeStatus": '现场部件类型状态',
    "statusSignalValue": '回路部件状态信号值',
    "authorization": '授权管理',
    "operatingVoltage": '工作电压'
  },
  "query": {
    "registeredAddress": '注册地址',
    "linkageProgramming": '联动编程',
    "historyRecord": '历史记录',
    "unitBoardInformation": '单元板卡信息',
    "annotationInformation": '注释信息',
    "unitConfiguration": '系统单元配置',
    "networkConfiguration": '组网配置',
    "authorizationManagement": '授权管理'
  }
}
